(function (window, undefined) {
  const SPACES = /\s+/;
  
  class EventTarget {
  
    _listeners = Object.create(null);
  
    _addEventListener(eventType, listener) {
      if (!(eventType in this._listeners)) {
        this._listeners[eventType] = [];
      }
  
      this._listeners[eventType].push(listener);
    }
  
    _removeEventListener(eventType, listener) {
      const eventListeners = this._listeners[eventType];
  
      if (!eventListeners) {
        return;
      }
  
      const index = eventListeners.indexOf(listener);
  
      if (index !== -1) {
        eventListeners.splice(index, 1);
      }
    }
  
    emit(event) {
      event.target = this;
  
      if (event.type in this._listeners) {
        [...this._listeners[event.type]].forEach((listener) => listener(event));
      }
    }
  
    off(eventTypes, listener) {
      if (typeof eventTypes === 'string') {
        eventTypes = eventTypes.split(SPACES);
      }
  
      eventTypes.forEach((eventType) => {
        this._removeEventListener(eventType, listener);
      });
    }
  
    on(eventTypes, listener) {
      if (typeof eventTypes === 'string') {
        eventTypes = eventTypes.split(SPACES);
      }
  
      eventTypes.forEach((eventType) => {
        this._addEventListener(eventType, listener);
      });
  
      return this.off.bind(this, eventTypes, listener);
    }
  
    one(eventTypes, listener) {
      const off = this.on(eventTypes, callback);
  
      function callback(event) {
        off();
        listener(event);
      }
    }
  }
  
  if (typeof window.acpv !== 'object') {
    window.acpv = {};
  }
  
  window.acpv.EventTarget = EventTarget;
  
})(window);
